var c=function(r){return r.CAR="car",r.PUBLIC="public",r.CARSHARING="carsharing",r}({});export{c as MobilityStatus};